module.exports = __webpack_public_path__ + "static/img/708c9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/livepoint/1.png
// module id = 652
// module chunks = 2